<template>
    <div class="lo footer">
        <mdSiteTools
            ref="tools"
            @sendEvent="receiveEvent"
        ></mdSiteTools>
        <mdShoppingArea
            v-if="showShopping"

            @sendEvent="receiveEvent"
        ></mdShoppingArea>
    </div>
</template>

<script>
    import mdSiteTools from '@/components/mdSiteTools'
    import mdShoppingArea from '@/components/mdShoppingArea'

    import { mapState, mapMutations } from 'vuex'

    export default {
        components: {
            mdSiteTools,
            mdShoppingArea,
        },
        data: function(){
            
            return {
                id: 'shopping-area',
                showShopping: false,
            }
        },
        computed: {
            ...mapState([
                'user',
            ]),
        },
        methods: {
            ...mapMutations([
                'pushPopUp',
                'globalClickFuncQueuePush',
                'globalClickFuncQueueRun',
                'globalClickFuncQueueClear',
            ]),
            toggleShoppingCart: function(){
                this.globalClickFuncQueueRun(this.id);
                this.showShopping = !this.showShopping;

                if( this.showShopping ){
                    this.$refs.tools.viewCart()
                }
            },
            hide: function(){
                this.showShopping = false;
            },
        },
        created: function(){
            this.globalClickFuncQueuePush({
                id: this.id,
                func: this.hide
            });
        },
        destroyed: function(){
            this.globalClickFuncQueueClear(this.id);
        },
    }
</script>

<style scoped lang="scss">

    .lo.footer {
        position: relative;
        z-index: 5;
    }
</style>
